// 用于表格中点击跳转后，自动填充
export default {
    namespaced: true,
    state: {
        xf_soft: "单网盘检索工具", //续费软件
        xf_name: "", //续费账号
        xf_term: "", //续费期限
        gm_soft: "单网盘检索工具", //改密软件
        gm_name: "", //改密账号
        pay_order:"", // 付款码顺序
        wx_code:"" // 付款码顺序
    },
    mutations: {
        changexfSoft(state, payload) {
            state.xf_soft = payload;
        },
        changexfName(state, payload) {
            state.xf_name = payload;
        },
        changexfTerm(state, payload) {
            state.xf_term = payload;
        },
        changegmSoft(state, payload) {
            state.gm_soft = payload;
        },
        changegmName(state, payload) {
            state.gm_name = payload;
        },
        changePayOrder(state, payload) {
            state.pay_order = payload;
        },
        changeWxCode(state, payload) {
            state.wx_code = payload;
        },
    }
}